import React from 'react';
import classnames from 'classnames';

const TextArea = ({ onChange, value, className, name, rows = 10, cols = 30, onBlur, id }, ref) => (
  <textarea
    ref={ref}
    name={name}
    id={id || name}
    cols={cols}
    rows={rows}
    onChange={onChange}
    onBlur={onBlur}
    value={value}
    className={classnames(
      'border-brandblue border-solid border rounded-lg py-2 px-4 w-full text-lg',
      className,
    )}
  />
);

export default React.forwardRef(TextArea);
